import { CORRIDOR_TYPES, type CorridorType, type LocationType } from '@/entities/dashboard/mapping';

import type { MapLayerId, MapReport } from '../model/types';

interface MapLayerConfig {
  labelKey: string;
  /** Marker slices the layer switches on. */
  reports: MapReport[];
  /** Corridor dataset the layer switches on. */
  corridorType?: CorridorType;
  /** Location types the layer draws plain icons for. */
  locationTypes?: LocationType[];
}

/**
 * The layer table of legacy RITA (`mapping.js:44-51`, `isReportEnabled:272-281`).
 *
 * Layers are independent checkboxes, not a single choice: "In-Progress" and
 * "Completed Journey" each own a corridor dataset and can be lit at the same time.
 */
export const MAP_LAYERS: Record<MapLayerId, MapLayerConfig> = {
  slc: { labelKey: 'welcome.servicelocations.label', reports: [], locationTypes: ['W', 'P'] },
  clc: { labelKey: 'welcome.customerlocations.label', reports: [], locationTypes: ['C'] },
  acs: { labelKey: 'welcome.accepted.services.desc', reports: ['RPU', 'RIC'] },
  ips: { labelKey: 'welcome.inprogress.services.desc', reports: ['SOH'], corridorType: CORRIDOR_TYPES.IN_TRANSIT },
  clr: { labelKey: 'welcome.releases.label', reports: ['REL'] },
  clt: { labelKey: 'welcome.itransfers.history.label', reports: [], corridorType: CORRIDOR_TYPES.IN_HOUSE }
};

/** Service Locations, "Accepted" Services and "In-Progress" Services, as legacy opens. */
export const DEFAULT_MAP_LAYERS: MapLayerId[] = ['slc', 'acs', 'ips'];

interface MapReportConfig {
  labelKey: string;
  /** Legacy slice colour (`mapping.js:286`). */
  color: string;
}

export const MAP_REPORT_CONFIG: Record<MapReport, MapReportConfig> = {
  RPU: { labelKey: 'dispatch.awaitingcollection.label', color: '#c0c4c6' },
  SOH: { labelKey: 'dispatch.stockonhand.label', color: '#f6da6d' },
  RIC: { labelKey: 'welcome.cargo.deliveries.desc', color: '#fdbea5' },
  REL: { labelKey: 'welcome.releases.label', color: '#d7867c' }
};
